__turbopack_context__.v({
  "isActive": "L9blAq_isActive",
  "navbarList": "L9blAq_navbarList",
});
